<template>
  <div
    class="modal_wrapper active"
    @click="closeModal()"
  >
    <div
      class="modal_window white_box create_report_modal"
      @click.stop=""
    >
      <div class="modal_header">
        <h3 class="tw-text-neutral-900 tw-text-2xl">
          Select Location
        </h3>
        <button
          class="close_modal close_btn"
          @click="closeModal()"
        >
          <svg
            fill="none"
            height="32"
            viewBox="0 0 32 32"
            width="32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 7L7 25"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M25 25L7 7"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </button>
      </div>

      <div class="section_modal_content white_box flex edit_section_modal mb_16">
        <div class="content">
          <custom-select
            v-if="activeWebsite.has_gmb_connection"
            v-model="selectedLocation"
            :options="gmbLocations"
            :validation-errors="errors"
            label="Location"
          />

          <div
            v-else
            class="widget_error"
          >
            <i class="fa fa-btn fa-exclamation-triangle" />
            <span>Please add a Google Business Profile location</span>
            <a href="/local/gmb/add">Add Location</a>
          </div>
        </div>
      </div>

      <div class="section_modal_footer">
        <button
          class="btn btn_md secondary_btn"
          @click="closeModal()"
        >
          <span>Close</span>
        </button>
        <button
          v-if="editing"
          class="btn btn_md primary_btn"
          @click="updateWidget()"
        >
          <span>Update</span>
        </button>
        <button
          v-if="!editing && activeWebsite.has_gmb_connection"
          class="btn btn_md primary_btn"
          @click="createWidget()"
        >
          <span>Create</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import CustomSelect from '../../../reports/components/global/forms/CustomSelect'

export default {
  components: {
    CustomSelect
  },
  emits: [
    'createWidget',
    'updateWidget',
  ],
  data() {
    return {
      selectedLocation: null,
      editing: false,
      errors: {},
    }
  },
  computed: {
    ...mapState('dashboard', ['activeWebsite', 'selectedOption', 'gmbLocations']),
  },
  mounted() {
    this.selectedLocation = this.selectedOption.widget.location_id ?? Object.keys(this.gmbLocations)[0];
    this.editing = (this.selectedOption.widget.editable)
    this.setSelectedOption(6);
  },
  methods: {
    ...mapActions({
      closeModal: 'dashboard/closeChooseLocationModal',
      openAddWidgetModal: 'dashboard/openAddWidgetModal',
    }),
    ...mapMutations({
      setSelectedOption: 'dashboard/setSelectedOptionIndex',
    }),
    createWidget() {
      if (!this.selectedLocation) {
        this.errors = {
          error: 'Please select a location'
        }
        return;
      }
      let widget = this.selectedOption.widget;
      widget.location_id = this.selectedLocation;
      widget.editable = 'chooseLocation';
      this.$emit('createWidget', {widget: widget});
      this.closeModal();
      this.openAddWidgetModal();
      this.SweetToast.fire({
        icon: 'success',
        title: 'Widget added successfully'
      });
    },
    updateWidget() {
      let widget = this.selectedOption.widget;
      widget.location_id = this.selectedLocation;
      this.$emit('updateWidget', {widget: widget});
      this.closeModal();
    },
  }
}
</script>

<style scoped>
.content {
  width: 100%;
}
</style>
<style scoped>
.section_modal_footer {
  display: flex;
  justify-content: flex-end;
}

.section_modal_footer button {
  height: 43px;
  padding: 0 1.5rem;
}

.custom_input {
  margin-bottom: 0;
}
</style>
